import { z } from "zod";

export const MfaFormSchema = z.object({
  challengeResponse: z
    .string()
    .length(6)
    .regex(/^[0-9]*$/),
});
